<template>
  <modal titulo="Processando Ação" id="processo-oficio" :loading="resumo.loading" :closeable="!resumo.loading">
    <p>
      <template v-if="resumo.mensagem">
        {{resumo.mensagem}} {{ resumo.contador ? `: ${resumo.atual} / ${resumo.total}`:''}}
      </template>
      <template v-if="resumo.erros.length > 0">
        <div></div>
        <br>
        <div>
          <span style="color:red">Erros encontrados[{{resumo.erros.length}}]</span>
        </div>
        <div v-for="(erro, index) in resumo.erros" :key="index">
          <span style="font-weight: bold;">Erro:</span> {{erro}}
        </div>
      </template>
    </p>
  </modal>

</template>

<script>
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";
import OficioBusiness from "@/business/oficio/OficioBusiness.js";
import RelatorioBusiness from "@/business/RelatorioBusiness";
import LacunaBusiness from "@/business/LacunaBusiness";

export default {
  name: "ModalAcaoLoteOficio",
  components: {Modal},
  props:{
    acao: { type: String, default: '' },
    oficios: {type: Array, default: () => []},
    forcarDownload:{type:Boolean ,default:false}
  },
  modal: {
    width: 800,
    escapable: false
  },
  data() {
    return {
      resumo : {
        mensagem: false,
        loading : true,
        total : 0,
        atual : 0,
        inicio : this.$moment(),
        fim : null,
        contador:true,
        erros:[]
      },
    }
  },
  mounted() {
    setTimeout(this.load, 100);
  },
  methods:{
    close() {
      FrontBusiness.closeModal();
    },

    async load() {
      this.resumo.total = this.oficios.length;
      switch (this.acao) {
        case 'BAIXAR_PDF':
          await this.downloadPDF();
          break;
        case 'BAIXAR_PDF_ASSINADO':
          await this.downloadPDFAssinado();
          break;
        case 'ASSINAR_PDF':
          await this.assinarPdf();
          break;
      }
    },

    nomeOficio(oficio) {
      return `${oficio.numero || ''}/${oficio.ano || ''}`;
    },

    async downloadPDF() {
      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const oficio of this.oficios) {
        this.$set(this.resumo, 'mensagem', 'Preparando Arquivos.');
        this.resumo.atual = index++;
        await RelatorioBusiness.downloadPdf(OficioBusiness.baixarOficio(oficio.id), `oficio-${oficio.numero}-${oficio.ano}.pdf`)
          .catch(erro => {
            numErros += 1;
            this.resumo.erros.push(`${this.nomeOficio(oficio)} - ${erro.message || 'Erro ao gerar pdf'}`)
          })
      }
      this.finalizarProcesso(numErros, this.oficios.length);
    },

    async downloadPDFAssinado() {
      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const oficio of this.oficios) {
        if (oficio.assinatura || this.forcarDownload) {
          this.$set(this.resumo, 'mensagem', 'Downloads dos arquivos.');
          this.resumo.atual = index++;
          const pdf = await LacunaBusiness.download('oficio', oficio.id)
            .catch(erro => {
              numErros += 1;
              this.resumo.erros.push(`${this.nomeOficio(oficio)} - ${erro.message || 'Erro ao buscar PDF assinado'}`)
            });

          if (pdf) {
            FrontBusiness.downloadFile(pdf, `oficio-${oficio.numero}-${oficio.ano}.pdf`);
          }

        } else {
          numErros += 1;
          this.resumo.erros.push(`${this.nomeOficio(oficio)} - Assinatura não encontrada`)
        }
      }
      this.finalizarProcesso(numErros, this.oficios.length);
    },

    async assinarPdf() {
      await LacunaBusiness.preauthorizeSignatures(await LacunaBusiness.getThumb(), this.oficios.length).catch(e => {
        FrontBusiness.showError('', 'Erro ao tentar utilizar o certificado digital. Realize seu login novamente.');
        this.close();
      });

      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const oficio of this.oficios) {
        this.$set(this.resumo, 'mensagem', 'Assinando Arquivos.');
        this.resumo.atual = index++;
        await LacunaBusiness.sign('oficio', oficio.id, '', `oficio-${oficio.numero}-${oficio.ano}.pdf`).catch(e => {
          numErros += 1;
          this.resumo.erros.push(`${this.nomeOficio(oficio)} - ${e?.message || e}`)
        });
      }
      this.finalizarProcesso(numErros, this.oficios.length);
    },

    finalizarProcesso(numErros, numOficios) {
      this.$set(this.resumo, 'contador', false);
      this.resumo.loading = false;
      if (numErros > 0 && numErros === numOficios) {
        this.$set(this.resumo, 'mensagem', `Falha na execução do processo.`);
      } else if (numErros > 0 && numErros < numOficios) {
        this.$set(this.resumo, 'mensagem', 'Concluído parcialmente.');
      }
      if (numErros === 0 && numOficios > 0) {
        this.$set(this.resumo, 'mensagem', 'Concluído.');
        this.close();
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
